export default __webpack_public_path__ + "static/media/workouttimes_3@2x.63fec008.jpg";